import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Button from '@material-ui/core/Button'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from '../../contexts/i18n/use'
import { useHistory } from 'react-router-dom'
import { useConfig } from '../../contexts/config/use'

export const QueueListItem = ({queuedata, officeID, bookTicket, disabled, disablecallback, hasform = false, showPeopleAhead, showWaitingTime, enableSneakySound}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const { actions: {GetUrlIDFromOfficeID, GetUrlIDFromQueueID }} = useConfig();
  const { actions: {t, qt}} = useTranslation();

  const calcTime = (seconds) => {
    if ( seconds === 0)
      return (t('queuepage.nowaitingtime'))
    if ( seconds < 60)
      return t('queuepage.lessthan') + " 1 " + t('queuepage.timeunits.minute')
    if ( seconds < 120)
      return "1 " + t ('queuepage.timeunits.minute')
    if ( seconds < 3600 )
      return Math.floor(seconds / 60).toString() + " " + t('queuepage.timeunits.minutes')
    else
      return t('queuepage.morethan') + " 1 " + t('queuepage.timeunits.hour')
  }

  const handleSubmit = () => {
    disablecallback(true);
    enableSneakySound();
    if (hasform)
    {
      history.push("forms?officeID=" + GetUrlIDFromOfficeID(officeID) + "&queueID=" + GetUrlIDFromQueueID(officeID, queuedata.queueID) + "&segmentID=" + queuedata.segmentID + "&serviceID=" + queuedata.serviceID);
      return;
    }
    else
      bookTicket(officeID, queuedata, null, t('queuepage.customertext'));
  }

  return (
    <ListItem className={[classes.container, "queues-listitems"].join(' ')} classes={{root: classes.root}}> 
      <ListItemText
        primary={<Typography component="span" variant="body1" className={[classes.primarytext, "queues-listitems-text-primary"].join(' ')}>{qt(queuedata.queueID) ? qt(queuedata.queueID) : queuedata.name}</Typography>}
        secondary={ <>
                      { showPeopleAhead
                        ? 
                        <Typography variant="body2" className={[classes.secodarytext, "queues-listitems-text-secondary"].join(' ')}>{t('queuepage.peoplewaiting') + " " + queuedata.peopleWaiting + t('queuepage.peoplewaitingsuffix')}</Typography>
                        :
                        <span/>
                      }
                      {
                        showWaitingTime
                        ? 
                        <Typography variant="body2" className={[classes.secodarytext, "queues-listitems-text-secondary"].join(' ')}>{t('queuepage.currentwaitingtime') + " " + calcTime(queuedata.actualWaitTime)}</Typography>
                        :
                        <span/>
                      }
                    </>
                  }/>
        <Button size="large" className={[classes.button, "queues-listitems-buttons"].join(' ')} onClick={handleSubmit} disabled={disabled} >
                { <Typography className="queues-listitems-buttons-text">{t('queuepage.ticketbutton') || "Köa"}</Typography>}
        </Button>
    </ListItem>
  ) 
}

const useStyles = makeStyles({
  container: theme => ({
    maxWidth: '500px',
    backgroundColor: theme.palette.listitem.main,
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem'
  }),
  button: theme => ({
    borderRadius: 0,
    color: theme.palette.button_text.main,
    backgroundColor: theme.palette.primary.main,
    minWidth: '15%',
    padding: '0.8rem 0.5rem',
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  primarytext: theme => ({
    color: theme.palette.button_text.main
  }),
  secondarytext: theme => ({
    color: theme.palette.secondary_text.main
  }),
  root: {
    margin: '0.25rem 0 0.25rem'
  }
})